import * as React from "react";
import { Tag } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { UploadedTmpFile } from "./FileUploadStore";
import { ActionCommand } from "./FileUploadActions";
interface UploadErrorStatusProps extends WithTranslation {
  status: API_UPLOADERRORINFO_STATUS;
  onStatusClick?: (command: string, file: UploadedTmpFile) => void;
  file?: UploadedTmpFile;
}

const uploadErrorStatusMap: { [key in API_UPLOADERRORINFO_STATUS]?: { label: string; command?: ActionCommand } } = {
  REPLACE: { label: "The file already exists", command: "replace_existing" },
  WHICHFILE: { label: "Unknown target file" },
  MISSINGMETADATUM: { label: "Missing meta data", command: "metadata" },
  RENAMEFILE: { label: "Name is not accepted", command: "rename" },
  FILENAMECONVENTION_FILENAME: { label: "Name is not accepted", command: "filename_assistant" },
  FILENAMECONVENTION_FILETYPE: { label: "File type not allowed" },
  ERROR: { label: "General error" },
  INDEX: { label: "Index" },
  LOCK: { label: "Locked" },
  DUPLICATE: { label: "Duplicate input" },
  NO_PDF: { label: "No PDF" },
  VIEW_NO_AUTOMAPPING: { label: "Not automappable" },
  MISSING_DESCRIPTION: { label: "Missing description" },
  ZIP_DIRECTORY: { label: "Invalid target", command: "change_path" },
  EMPTY_FILE: { label: "Remove empty file", command: "remove" },
  DELETED_DIR: { label: "Remove file", command: "remove" },
  // 'INVALID_TARGET': { label: 'Invalid target', command: 'target'  },
};

export const UploadErrorStatus = withTranslation(I18N_NS.PROJECT)(
  ({ t, status, onStatusClick, file }: UploadErrorStatusProps) => {
    const handleClick = React.useCallback(() => {
      if (onStatusClick && uploadErrorStatusMap[status].command && file) {
        onStatusClick(uploadErrorStatusMap[status].command, file);
      }
    }, [file, onStatusClick, status]);

    return (
      <Tag color="#ff8145" onClick={handleClick} className="pointer" variant="solid">
        {uploadErrorStatusMap[status] ? t(uploadErrorStatusMap[status]?.label) : status}
      </Tag>
    );
  }
);
